import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    fetchAdmins() {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/admins')
          .then(response => {
            const { data } = response.data
            resolve(data)
          })
          .catch(error => reject(error))
      })
    },
    putAdmin(ctx, adminData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put('/admins', adminData)
          .then(response => {
            const { data } = response.data
            resolve(data)
          })
          .catch(error => reject(error))
      })
    },
    switchCountry(_, payload) {
      return axiosIns.put('/admins/switch-country', payload)
    },
  },
}
